import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs';
import { IRoleLookup } from '../../state/roles/roles.state';
import { environment } from '../../../../environments/environment';

export const UserManagementEndpoints = {
  getRoles: `${environment.apiUrl}/RoleAPI/GetAll`,
};

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  private http: HttpClient = inject(HttpClient);

  getAllRoles() {
    return this.http.post(UserManagementEndpoints.getRoles, {});
  }

  getCopilotRoles() {
    return this.http.post<{ data: IRoleLookup[] }>(UserManagementEndpoints.getRoles, { return_service_role: true }).pipe(
      map(response => response.data.filter(r => r.name.startsWith('Copilot_')))
    );
  }
}
